// utils.js
const prefixNum = (num) => {
    if(parseInt(num) < 10) {
        return `0${num}`
    } else {
        return num
    }
}

const getQueryString = (url, name) => {      // 获取url参数
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let params = url.split("?")[1]
    if(params) {
        let r = params.match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
    }
    return null;
}

const checkEmail = (email) => {         // 验证邮箱格式是否正确
    const reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
    return reg.test(email);
}

const getUrlRelativePath = (sns) => {       // 构造第三方登入url
    let url = document.location.toString();
    let arrUrl = url.split("//");
    let start = arrUrl[1].indexOf("/");
    let relUrl = arrUrl[0] + "//" + arrUrl[1].substring(0, start) + "/dormdesign/auth/" + sns;
    console.log(relUrl)
    return relUrl;
}

const openWin = (url,name,iWidth,iHeight) => {      // 打开新窗口
    //获得窗口的垂直位置 
    var iTop = (window.screen.availHeight - 30 - iHeight) / 2; 
    //获得窗口的水平位置 
    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2; 
    window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'); 
}

const openLogin = (sns) => {      // 新窗口
    //窗口高度
    let iHeight = 500;
    //窗口宽度
    let iWidth = 850;
    //获得窗口的垂直位置
    let iTop = (window.screen.availHeight- iHeight) / 2;
    //获得窗口的水平位置
    let iLeft = (window.screen.availWidth - iWidth) / 2;
    let windowStyle = 'height=' + iHeight + ',width=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no';

    let url = getUrlRelativePath(sns)
    let snsLogin = window.open(url, 'newwindow', windowStyle)

    return snsLogin
}

const snsShare = (channel, videoid) => {     // sns分享
    console.log(videoid)
    switch (channel) {
        case 'fb':
            openWin('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(`${window.location.origin}/dormdesign/watch?worksid=${videoid}\n`), 'sharer', 626, 736)
            break;
        case 'tw': 
            // openWin('https://twitter.com/intent/tweet?url' + encodeURIComponent(`https://ccvideocontest.arknights.global/watch?worksid=${videoid}&text=Contingency Contract Video Contest&via=ArknightsEN`), 'sharer', 626, 250)
            window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(`${window.location.origin}/dormdesign/watch?worksid=${videoid}`) + '&text=2021 winter 宿舎デザイン投稿キャンペーン' + '&hashtags=アークナイツ,宿舎デザイン' + '&via=ArknightsStaff\n', "_blank")
            break;
        default:
            break;
    }
}

const formatTime = (time) => {
    let year = new Date(time).getFullYear()
    let month = new Date(time).getMonth() + 1
    let date = new Date(time).getDate()
    let hour = new Date(time).getHours()
    let min = new Date(time).getMinutes()

    if(month < 10) {
        month = `0${month}`
    }
    if(date < 10) {
        date = `0${date}`
    }
    if(hour < 10) {
        hour = `0${hour}`
    }
    if(min < 10) {
        min = `0${min}`
    }
    return `${year}/${month}/${date} ${hour}:${min}`;
}


const preFetch = (list) => {
  // 空闲时，加载即将会用到的资源
  for (let i = 0, len = list.length; i < len; i++) {
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.href = list[i];
      document.head.appendChild(link);
  }
}

export default {
    prefixNum,
    getQueryString,
    checkEmail,
    openLogin,
    formatTime,
    openWin,
    snsShare,
    preFetch
}